/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_All_DayInputs */

const en_colleague_all_day = /** @type {(inputs: Colleague_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

const ja_colleague_all_day = /** @type {(inputs: Colleague_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終日`)
};

const fr_colleague_all_day = /** @type {(inputs: Colleague_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute la journée`)
};

const de_colleague_all_day = /** @type {(inputs: Colleague_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganztägig`)
};

/**
* | output |
* | --- |
* | "All day" |
*
* @param {Colleague_All_DayInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_all_day = /** @type {((inputs?: Colleague_All_DayInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_All_DayInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_all_day(inputs)
	if (locale === "ja") return ja_colleague_all_day(inputs)
	if (locale === "fr") return fr_colleague_all_day(inputs)
	return de_colleague_all_day(inputs)
});